import { IDateRange } from '../../../types/dateRange';
import { ICalendarDateRange } from '../types';
import { formatCalendarDate } from './formatCalendarDate';

export function formatCalendarDateRange(dateRange: ICalendarDateRange): IDateRange {
  return {
    from: dateRange.from ? formatCalendarDate(dateRange.from) : null,
    to: dateRange.to ? formatCalendarDate(dateRange.to) : null,
  };
}
